<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>account_box</md-icon>
          </div>
          <h4 class="title">予約詳細</h4>
        </md-card-header>

        <md-card-content class="formLayout">
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              注文番号
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{orderNumber}}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              支払番号
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{approveNo}}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              予約日
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{orderDate | dateFormat}}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              サービス開始時刻
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{startDay | timeFormat}}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              サービス終了時刻
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{endDay | timeFormat}}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ステータス
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <md-field class="productStatus">
                <md-select v-model="orderStatus" name="status">
                  <md-option value="accept">予約中</md-option>
                  <md-option value="recieved">実施済み</md-option>
                  <md-option value="cancel">キャンセル</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              予約者名
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{ name }}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              予約店舗
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{shopName}}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              担当
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <p class="form-control-static">{{ staffName }}</p>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              予約金額
            </label>
            <div class="md-layout-item md-size-30 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('totalPrice')},
                {'md-valid': !errors.has('totalPrice') && touched.totalPrice}]">
                <md-input
                  type="number"
                  v-model="totalPrice"
                  data-vv-name="totalPrice"
                  v-validate= "modelValidations.totalPrice"
                  required>
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('totalPrice')">【必須】6桁以内の半角数字で入力してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('totalPrice')" style="margin-right:10px">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('totalPrice') && touched.totalPrice" style="margin-right:10px">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              コメント
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <md-field>
                <md-textarea v-model="comment"></md-textarea>
              </md-field>
            </div>
          </div>

        </md-card-content>
        <md-card-actions class="mx-auto" md-alignment="left">
          <md-button class="md-warning md-lg" @click.native.prevent="returnBack">戻る</md-button>
          <md-button class="md-success md-lg mL40" @click.native.prevent="validate">更新</md-button>
        </md-card-actions>
      </md-card>

      <md-card class="mt30">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">予約内容</h4>
        </md-card-header>
        <md-card-content>
          <div class="dataTableWrapper">
            <div class="dataTable"> 
              <div class="tHead">
                <div class="tHead_th t_image">商品画像</div>
                <div class="tHead_th">商品名</div>
                <div class="tHead_th taC">税区分</div>
                <div class="tHead_th taR">商品金額</div>
                <div class="tHead_th taR">個数</div>
                <div class="tHead_th taR">合計</div>
              </div>
              <div v-for="item in shoppingCartTable" :data-id="item.id" class="tItem" :key="item.id">
                <div class="tItem_td t_image"><img :src="item.img" alt=""></div>
                <div class="tItem_td"><md-label style="word-break:break-all;">{{ item.name }}</md-label></div>
                <div class="tItem_td taC"><md-icon>{{item.taxIcon}}</md-icon></div>
                <div class="tItem_td taR boldCell">¥{{ item.price | numberWithDelimiter}}</div>
                <div class="tItem_td taR">{{ item.quantity }}</div>
                <div class="tItem_td taR boldCell">¥{{ item.priceIncludingTax * item.quantity | numberWithDelimiter}}</div>
              </div>
            </div>
          </div>
          <div class="table table-stats">
            <div class="td-price td-price-top">
              <div class="td-total">
                 税抜合計
              </div>
              <span>
                <small>¥</small>
                {{this.totalPriceWithoutTax | numberWithDelimiter}}
              </span>
            </div>
            <div class="td-price">
              <div class="td-total">
                 ポイント利用
              </div>
              <span>
                {{this.usePoint | numberWithDelimiter}}
              </span>
            </div>
            <div class="td-price">
              <div class="td-total">
                 8%税率対象合計
              </div>
              <span>
                <small>¥</small>
                {{this.taxReduce | numberWithDelimiter}}
              </span>
            </div>
            <div class="td-price">
              <div class="td-total">
                10%税率対象合計
              </div>
              <span>
                <small>¥</small>
                {{this.taxNormal | numberWithDelimiter}}
              </span>
            </div>
            <div class="td-price">
              <div class="td-total">
                税込合計
              </div>
              <span style="font-weight: bold">
                <small style="font-weight: bold">¥</small>
                {{this.totalPrice | numberWithDelimiter}}
              </span>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>

</template>

<script>
  import router from '../packs/router.js'
  import role from "../mixins/role.js"

  export default {
    mixins: [ role ],
    components: {
    },
    computed: {
    },
    props: {
    },
    data () {
      return {
        approveNo: '',
        orderNumber: '',
        name: '',
        shopName: '',
        staffName: '',
        orderDate: '',
        orderStatus: '',
        startDay: '',
        endDay: '',
        comment: '',
        usePoint: '',
        taxReduce: '',
        taxNormal: '',
        totalPriceWithoutTax: '',
        totalPrice: '',
        id: '',
        shoppingCartTable: [],
        touched: {
          totalPrice: false,
        },
        modelValidations: {
          totalPrice: {
            required: true,
            numeric: true,
            max: 6
          }
        }
      }
    },
    methods: {
      returnBack () {
        router.push({ path: '/admin/reserve_order_list/' })
      },
      getOrders () {
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/reserve_orders/' + this.$route.params.id,
          timeout : 10000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.id = response.data.id
          this.orderNumber = response.data.order_number
          this.orderDate = response.data.created_at
          this.orderStatus = response.data.order_status
          this.approveNo = response.data.approve_no
          this.shopName = response.data.shop_name
          this.name = response.data.user_name
          this.comment = response.data.memo
          this.staffName = response.data.staff_name !== null ? response.data.staff_name : '指名なし'
          this.startDay = response.data.reserved_start_time
          this.endDay = response.data.reserved_end_time
          this.usePoint = response.data.use_point
          this.totalPriceWithoutTax = Math.floor(response.data.total_price_without_tax)
          this.taxReduce = Math.floor(response.data.tax_reduce)
          this.taxNormal = Math.floor(response.data.tax_normal)
          this.totalPrice = Math.floor(response.data.total_price)
          this.createList(response.data.reserve_order_details)
        })
        .catch(error => {
          this.dangerNotify('予約情報の取得に失敗しました')
        })
      },
      createList (obj) {
        for (var i in obj) {
          var item = {
            img: obj[i].main_image.url !== null ? obj[i].main_image.url : '/images/no_image.png',
            name: obj[i].product_name !== null ? obj[i].product_name : '商品名がありません',
            taxIcon: obj[i].tax_rate == "reduced" ? "exposure_neg_2" : obj[i].tax_rate == "free" ? "exposure_zero" : "",            
            quantity: obj[i].quantity,
            price: obj[i].sales_price,
            priceIncludingTax: obj[i].price_including_tax
          }
          this.shoppingCartTable.push(item)
        }
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.updateStatus()
          } else {
            this.validateError();
          }
        })
      },
      updateStatus () {
        var param = {
          order_status: this.orderStatus,
          total_price: this.totalPrice,
          memo: this.comment
        }
        this.axios({
          method  : 'PUT',
          url     : this.AdminApiUrl + '/reserve_orders/' + this.id,
          timeout : 10000,
          headers : {'Authorization': this.$Cookies.get('accessToken')},
          data: {
            reserve_order : param
          }
        }).then(response => {
          this.successAndBackPage('予約情報を更新しました')
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('予約情報の更新に失敗しました')
          }
        })
      },
    },
    mounted () {
      if (!this.opt_reserveOrder) {
        router.push({ path: '/admin/login'})
        return false
      }
      this.getOrders()
    },
    watch: {
      totalPrice(){
        this.touched.totalPrice = true
      }
    }
  }
</script>

<style lang="scss" scoped>
.md-card .md-card-actions{
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.form-control-static{
  margin-top: 9px;
}

.mt30{
  margin-top: 30px;
}

.productStatus{
  max-width: 120px;
  width: 100%;
  display: inline-block;
}

.btnUpdate{
  margin: 10px 0 0 20px;
}

.text-right /deep/ .md-table-cell-container{
  display: flex;
  justify-content: flex-end;
}
.md-table /deep/ .md-table-head:last-child{
  text-align: right;
}

.table-stats {
  display: flex;
  align-items: center;
  text-align: right;
  flex-flow: row wrap;

  .td-price .td-total{
    display: inline-flex;
    font-weight: 500;
    font-size: 14px;
    margin-right: 50px;
  }

  &.table-striped .td-price{
    border-bottom: 0;
  }

  .td-price{
    font-size: 16px;
    border-bottom: 1px solid #d2d2d2;
  }

  .td-price-top{
    border-top: 1px solid #d2d2d2;
  }

  .td-price,
  > div{
    flex: 0 0 100%;
    padding: 12px 8px;
  }

  span{
    display: inline-block;
    width: 15%;
  }

}

.btnCenter{
  margin-left: auto !important;
  margin-right: auto !important;
}

.taC{
  text-align: center;
}

.mt30{
  margin-top: 30px;
}

.mt60{
  margin-top: 60px;
}

.pr60{
  padding-right: 60px;
}

.is-l-none{
  display: none;
}

@media screen and (max-width:600px) {
  .md-card .md-card-content .md-form-label{
    text-align: left;
  }

  .is-xs-none{
    display: none;
  }

  .is-xs-block{
    display: block;
  }
}

</style>
